export const blockIconsSearchCameraOutdoor = (
	<span className='material-symbols-outlined'>camera_outdoor</span>
);
